import {React, useEffect, useState} from 'react';
import { Navigation } from './commons/navigation.tsx';
import ToolsContent from './commons/tools-content-general.tsx';
import { Notifications } from './commons/notifications.tsx';
import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  ContentLayout,
  SpaceBetween,
  Flashbar,
  Header,
  HelpPanel,
  Link,
  SideNavigation,
  SplitPanel,
} from '@cloudscape-design/components';

/* class Tools extends Component {
    constructor(props) {
      super(props);
      this.state = { toolsIndex: 0, toolsOpen: false, tags: [], valid: true, loading: true };
      this.appLayout = createRef();
    }
} */

export default function () {
    const [toolsOpen, setToolsOpen] = useState(true);
    const [navOpen, setNavOpen] = useState(true);
  
    return (
        <AppLayout
          breadcrumbs={
            <BreadcrumbGroup
              items={[
                { text: 'Plantly', href: '#' },
                { text: 'Getting-Started', href: '#' },
              ]}
            />
          }
          navOpen={navOpen}
          onNavChange={({ detail }) => setNavOpen(detail.open)}
          navigation={<Navigation activeHref="/gettingstarted" />}
          notifications={<Notifications />}
          toolsOpen={toolsOpen}
          onToolsChange={({ detail }) => setToolsOpen(detail.open)}
          tools={ToolsContent}
          content={
            <ContentLayout header={<Header variant="h1">Getting Started</Header>}>
                <SpaceBetween size="s">
                <Container
                    
                    header={
                    <Header
                        variant="h2"
                        //info={<InfoLink onFollow={handleInfoClick} />}
                        description="Learn how to do it here."
                    >
                        Want to set up your own Plantly?
                    </Header>
                    }
                >
                </Container>
                <Container>
                    <p>Plantly demonstrates both Amazon’s commitments to a more sustainable future and AWS technology capabilities for remote monitoring of assets in different use cases from agriculture to manufacturing. It invites you to rethink how to use AWS offerings and technology for sustainability use-cases, even though not directly related to the topic such as Alexa.</p>
                    <p>Plantly showcases remote monitoring capabilities using AWS services while ensuring accessibility through different means (vision, voice/hearing). Different sensors track different metrics, like soil moisture, humidity and temperature. On a tablet, customers can see a dashboard showing the different metrics. An Alexa device is placed in front of the plant wall to let customers interact with the living plant wall. They can ask Plantly how the plants are doing and about different metrics of the plants. Plantly is also inviting customers to play a quiz on the topic of sustainability and water.</p>
                </Container>
                <Container> 
                    <Header
                        variant="h2"
                        description=""
                    >
                        Plantly Hardware Elements
                    </Header>
                    <div>
                        <p>
                        Plantly uses a microcontroller and different sensors. It is based on Core2 for AWS, the reference hardware kit for AWS IoT, which comes with an ESP32-D0WDQ6-V3 micro controller.
                        Sensors and pump are connected to a gateway device (M5 Stack Core 2) that connects to AWS via a secured connection.
                        </p>
                        <ul>
                        <li>
                            Device Gateway: <a href="https://shop.m5stack.com/products/m5stack-core2-esp32-iot-development-kit-for-aws-iot-edukit?variant=37687799251116">M5 Stack Core 2</a>
                        </li>
                        <li>
                            Temperature and Humidity Sensor: <a href="https://shop.m5stack.com/products/env-iii-unit-with-temperature-humidity-air-pressure-sensor-sht30-qmp6988">ENV III Unit</a>
                        </li>
                        <li>
                            Soil Sensor: <a href="https://shop.m5stack.com/products/earth-sensor-unit">Earth Moisture Sensor Unit</a>
                        </li>
                        <li>
                            Water Pump: <a href="https://shop.m5stack.com/products/watering-unit-with-mositure-sensor-and-pump">Watering Unit</a>
                        </li>
                        </ul>
                        <p>
                        <a href="https://docs.m5stack.com/en/quick_start/core2/uiflow">Find here how to set up the M5 Stack Core2.</a> and follow <a href="https://catalog.workshops.aws/sustainability-hackathon/en-US">Build a Builder Workshop</a> to understand how to set up the sensors and connection to AWS IoT Core.
                        </p>
                    </div>         
                </Container>
                <Container>
                    <Header variant="h2" description="">
                        Collecting sensor data
                    </Header>
                    <p>
                        Different sensors collect data about the environment (temperature,
                        humidity, soil moisture) and send them to AWS IoT Core
                        through a device gateway, using a <a href="https://docs.aws.amazon.com/iot/latest/developerguide/x509-client-certs.html">secured connection</a> (TLS) and through the MQTT protocol. See <a href="https://docs.aws.amazon.com/iot/latest/developerguide/protocols.html">
                        Connecting devices to AWS IoT
                        </a>
                        .
                    </p>
                    <p>
                        Different <a href="https://docs.aws.amazon.com/iot/latest/developerguide/iot-rules.html">Rules for AWS IoT</a> redirect the data to:
                    </p>
                    <ul>
                        <li>
                        A DynamoDB table, to be consumed by the Alexa Skill and Amazon
                        Quicksight
                        </li>
                        <li>
                        <a href="https://docs.aws.amazon.com/iotevents/latest/developerguide/what-is-iotevents.html">
                            AWS IoT Events
                        </a>
                        , where a state machine changes status depending on the soil moisture
                        of the plant to activate the water pump when needed
                        </li>
                        <li>
                        <a href="https://aws.amazon.com/es/iot-sitewise/">
                            AWS IoT SiteWise
                        </a>
                        , that allows to collect, organize, and analyze data from industrial
                        equipment at scale.
                        </li>
                    </ul>
                    </Container>
                    <Container>
                    <Header variant="h2" description="">
                        Data analysis and visualization
                    </Header>
                    <p>
                        Data is consumed in two ways:
                    </p>
                    <ul>
                        <li>
                        <strong>Via an <a href="https://docs.aws.amazon.com/iot-sitewise/latest/userguide/monitor-data.html">
                            AWS IoT SiteWise Monitor
                            </a>
                        </strong>
                        : SiteWise Monitor is a feature of AWS IoT SiteWise that you can use
                        to create portals in the form of a managed web application. In
                        Plantly, we use portals to view our plants data.
                        </li>
                        <li>
                        <strong>Via an Alexa device</strong>: through an Alexa Skill.
                        Customers can interact with Alexa to: (1) ask questions about
                        Plantly status, (2) water a specific plant.
                        </li>
                    </ul>
                    </Container>
                    <Container>
                    <Header variant="h2" description="">
                        Architecture Diagram
                    </Header>
                        <p>Check out the detailed architecture diagram with description of steps <a href="/architecture.html">here</a></p>
                    </Container>
                </SpaceBetween>
            </ContentLayout>
          }
        />
    );
  }





